module.exports = __webpack_public_path__ + "img/wanc1.a1ae9608.png";